import { Action } from "./action";
import { Actions } from "./actions";

interface VonageLogoutCodesModel {
  logoutCodes: Array<object>;
}

const initial: VonageLogoutCodesModel = {
    logoutCodes: []
};

export const vonageLogoutCodes = (context: any) => {
  const { log } = context;
  return (
    state: VonageLogoutCodesModel = initial,
    action: Action<Actions>
  ) => {
    let updated = state;
    const { type, payload } = action;
    switch (type) {
      case Actions.SETLOGOUTCODES:
        updated = { ...updated, ...payload };
        break;
    }
    return updated;
  };
};
